import { useState } from "react"
import { useTranslation } from "react-i18next"
import InfoIcon from "../../../../../assets/images/info.png"
import "./style/Settings.scss"

const Settings = () => {
  const { t } = useTranslation()

  const [theme, setTheme] = useState("dark")
  const [riseFallColor, setRiseFallColor] = useState("green-up")
  const [interfaceLayout, setInterfaceLayout] = useState("horizontal")
  const [valueFormat, setValueFormat] = useState("standard")
  const [notifications, setNotifications] = useState({
    events: true,
    listings: true,
    messagePopup: true,
    telegramP2P: false
  })

  const [automation, setAutomation] = useState({
    managerTrade: false,
    aiBotTrade: false,
    platformBotTrade: false
  })

  const [showDetails, setShowDetails] = useState<null | "manager" | "ai" | "platform">(null)

  return (
    <div className="settings-page">
      <h2>{t("settings.title")}</h2>

      <div className="section">
        <h3>{t("settings.trading")}</h3>

        <div className="row">
          <label>{t("settings.theme")}</label>
          <select value={theme} onChange={e => setTheme(e.target.value)}>
            <option value="light">{t("settings.light")}</option>
            <option value="dark">{t("settings.dark")}</option>
          </select>
        </div>

        <div className="row">
          <label>{t("settings.riseFall")}</label>
          <select value={riseFallColor} onChange={e => setRiseFallColor(e.target.value)}>
            <option value="green-up">{t("settings.greenUp")}</option>
            <option value="red-up">{t("settings.redUp")}</option>
          </select>
        </div>

        <div className="row">
          <label>{t("settings.interface")}</label>
          <select value={interfaceLayout} onChange={e => setInterfaceLayout(e.target.value)}>
            <option value="standard">{t("settings.standard")}</option>
            <option value="horizontal">Horizontal</option>
            <option value="vertical">Vertical</option>
          </select>
        </div>

        <div className="row">
          <label>{t("settings.valueFormat")}</label>
          <select value={valueFormat} onChange={e => setValueFormat(e.target.value)}>
            <option value="standard">{t("settings.standard")}</option>
            <option value="indented">{t("settings.indented")}</option>
          </select>
        </div>
      </div>

      <div className="section">
        <h3>{t("settings.notifications")}</h3>

        <div className="switch-row">
          <label>{t("settings.msgPopup")}</label>
          <input
            type="checkbox"
            checked={notifications.messagePopup}
            onChange={() =>
              setNotifications(prev => ({ ...prev, messagePopup: !prev.messagePopup }))
            }
          />
        </div>

        <div className="switch-row">
          <label>{t("settings.events")}</label>
          <input
            type="checkbox"
            checked={notifications.events}
            onChange={() =>
              setNotifications(prev => ({ ...prev, events: !prev.events }))
            }
          />
        </div>

        <div className="switch-row">
          <label>{t("settings.listings")}</label>
          <input
            type="checkbox"
            checked={notifications.listings}
            onChange={() =>
              setNotifications(prev => ({ ...prev, listings: !prev.listings }))
            }
          />
        </div>
      </div>

      <div className="section">
        <h3>{t("settings.telegram")}</h3>

        <div className="switch-row">
          <label>{t("settings.p2p")}</label>
          <input
            type="checkbox"
            checked={notifications.telegramP2P}
            onChange={() =>
              setNotifications(prev => ({ ...prev, telegramP2P: !prev.telegramP2P }))
            }
          />
        </div>
      </div>

      <div className="section autoTrading">
        <h3>{t("settings.autoTrading")}</h3>

        <div className="switch-row">
          <label>
            {t("settings.manager")}
            <span className="info-icon" onClick={() => setShowDetails("manager")}><img src={InfoIcon}/></span>
          </label>
          <input
            type="checkbox"            
            checked
            onChange={() =>
              setAutomation(prev => ({ ...prev, managerTrade: !prev.managerTrade }))
            }
          />
        </div>

        <div className="switch-row">
          <label>
            {t("settings.aiBot")}
            <span className="info-icon" onClick={() => setShowDetails("ai")}><img src={InfoIcon}/></span>
          </label>
          <input
            type="checkbox"
            checked
            onChange={() =>
              setAutomation(prev => ({ ...prev, aiBotTrade: !prev.aiBotTrade }))
            }
          />
        </div>

        <div className="switch-row">
          <label>
            {t("settings.platformBot")}
            <span className="info-icon" onClick={() => setShowDetails("platform")}><img src={InfoIcon}/></span>
          </label>
          <input
            type="checkbox"
            disabled
            checked={automation.platformBotTrade}
            onChange={() =>
              setAutomation(prev => ({ ...prev, platformBotTrade: !prev.platformBotTrade }))
            }
          />
        </div>
      </div>

      {showDetails && (
        <div className="modal-backdrop" onClick={() => setShowDetails(null)}>
          <div className="modal-content" onClick={e => e.stopPropagation()}>
            <h4>{t("settings.moreInfo")}</h4>
            {showDetails === "manager" && (
              <>
                <p>{t("settings.info.manager")}</p>
                <p>{t("settings.info.managerDetail")}</p>
              </>
            )}
            {showDetails === "ai" && (
              <>
                <p>{t("settings.info.ai")}</p>
                <p>{t("settings.info.aiDetail")}</p>
                <p><strong>{t("settings.info.aiRequirement")}</strong></p>
              </>
            )}
            {showDetails === "platform" && (
              <>
                <p>{t("settings.info.platform")}</p>
                <p>{t("settings.info.platformDetail")}</p>
                <p><strong>{t("settings.info.platformRequirement")}</strong></p>
              </>
            )}
            <button onClick={() => setShowDetails(null)}>{t("settings.close")}</button>
          </div>
        </div>
      )}
    </div>
  )
}

export default Settings
